<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-card>
          <div slot="header">
            <strong>Resumen de Comisiones de Ventas Cobradas por Vendedor</strong>
          </div>
          <b-form>
            <b-form-group
              label="Vendedor"
              label-for="vendedor"
              :label-cols="labelCols"
              horizontal>
              <b-input-group>
                <b-input-group-append 
                    class="filter-search-icons" 
                    @click="seleccionarVendedor">
                  <b-input-group-text>
                    <i :class="{ 'fa fa-search': !vendedor,
                                  'fa fa-remove': vendedor  }"></i>
                  </b-input-group-text>
                </b-input-group-append>
                <b-form-input 
                  id="vendedor"
                  :value="vendedorNombre"
                  readonly
                  type="text"/>
              </b-input-group>
            </b-form-group>

            <b-form-group
              label="Fecha Desde"
              label-for="fechaDesde"
              :label-cols="labelCols"
              description="Desde qué fecha de cobro"
              horizontal>
              <b-form-input 
                id="fechaDesde" 
                v-model="fechaDesde" 
                :state="fechaDesdeValida"
                type="date"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="fechaDesdeFeedback">
                {{ fechaDesdeInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Fecha Hasta"
              label-for="fechaHasta"
              :label-cols="labelCols"
              description="Hasta qué fecha de cobro"
              horizontal>
              <b-form-input 
                id="fechaHasta" 
                v-model="fechaHasta" 
                :state="fechaHastaValida"
                type="date"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="fechaHastaFeedback">
                {{ fechaHastaInvalidaMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Cliente"
              label-for="cliente"
              :label-cols="labelCols"
              horizontal>
              <b-input-group>
                <b-input-group-append 
                    class="filter-search-icons" 
                    @click="seleccionarCliente">
                  <b-input-group-text>
                    <i :class="{ 'fa fa-search': !cliente,
                                  'fa fa-remove': cliente  }"></i>
                  </b-input-group-text>
                </b-input-group-append>
                <b-form-input 
                  id="cliente"
                  :value="clienteNombre"
                  readonly
                  type="text"/>
              </b-input-group>
            </b-form-group>
          </b-form>
          <div slot="footer">
            <b-button size="sm" variant="primary" class="footer-button"
              @click.prevent="emitirResumen">Emitir Resumen</b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>

    <b-modal ref="searchVendedorModal"
        title="Seleccionar Vendedor"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="proveedores-search-modal">
      <app-search-vendedor
        @vendedorSeleccionado="vendedorSeleccionado">
      </app-search-vendedor>  
    </b-modal>

    <b-modal ref="searchClienteModal"
        title="Seleccionar Cliente"
        header-bg-variant= "light" 
        hide-footer
        lazy
        modal-class="search-modal">
      <app-search-cliente
        :incluirInactivos="true"
        @clienteSeleccionado="clienteSeleccionado">
      </app-search-cliente>  
    </b-modal>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import SearchVendedor from '../vendedores/SearchList.vue';
import SearchCliente from '../clientes/SearchList.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs'
import exportResumenPDF from '../../mixins/export_comisiones_cobros_vendedor_pdf.js';
import moment from 'moment';

export default {
  name: 'VendedoresComisionesCobrosResumen',
  components: {
    appSearchVendedor: SearchVendedor,
    appSearchCliente: SearchCliente,
    appMensaje: Mensaje
  },
  mixins: [
    msjModal,
    exportResumenPDF
  ],
  data () {
    return {
      /* Validacion de datos */
      noValidar: true,
      fechaDesdeValida: null,
      fechaDesdeInvalidaMsj: '',
      fechaHastaValida: null,
      fechaHastaInvalidaMsj: '',

      fechaDesde: moment(new Date()).format('YYYY-MM-DD'),
      fechaHasta: moment(new Date()).format('YYYY-MM-DD'),
      vendedor: null,
      cliente: null,

      labelCols: 2,
    }
  },
  computed: {
    vendedorNombre() {
      return this.vendedor? this.vendedor.nombre.trim() : '';
    },
    clienteNombre() {
      return this.cliente? this.cliente.nombre.trim() : '';
    },
  },
  created() {
    
  },  
  methods: {
    validate() {
    },
    emitirResumen () {
      let execute = true;

      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      let vendedorId = 0;
      if (this.vendedor) {
        vendedorId = this.vendedor.id;
      }

      if (vendedorId == 0) {
        this.showErrorMsj(new Error('Debe seleccionar un vendedor para emitir el resumen.'))
        execute = false;
      }

      let clienteId = 0;
      if (this.cliente) {
        clienteId = this.cliente.id;
      } 

      let params = {
        fechaDesde: this.fechaDesde,
        fechaHasta: this.fechaHasta,
        vendedorId,
        clienteId
      }

      if (execute) {
        let empresa;

        this.showSpinner();
        this.$store.dispatch('empresa/inicializar')
          .then(() => {
            empresa = this.$store.getters['empresa/empresa'];
            return;
          })
          .then(() => {
            return this.$store.dispatch('vendedores/getResumenComisionesCobrosVendedor', params)
          })
          .then(() => {
            let resumen = this.$store.getters['vendedores/resumenComisionesCobrosVendedor'];

            if (resumen) {
              this.exportPDFComisionesCobrosVendedor(resumen, empresa);
            } else {
              this.showModalMsj('Se produjo un error al recuperar el resumen de comisiones', null, null, 'light')
            }
          })
          .catch(error => this.showErrorMsj(error))
          .finally(() => this.hideSpinner());
      }
    },
    seleccionarVendedor() {
      if (this.vendedor) {
        this.vendedor = null;
      } else {
        this.$refs.searchVendedorModal.show();
      }
    },
    vendedorSeleccionado(item) {
      this.vendedor = item;
      this.$refs.searchVendedorModal.hide();
    },
    seleccionarCliente() {
      if (this.cliente) {
        this.cliente = null;
      } else {
        this.$refs.searchClienteModal.show();
      }
    },
    clienteSeleccionado(item) {
      this.cliente = item;
      this.$refs.searchClienteModal.hide();
    },
  },
}
</script>

<style>
</style>
